var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSaveselection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2f0e0305-81a2-4f65-bd43-bda94837d034",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.8 73.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,21.72v44.17c0,4.37-3.54,7.91-7.91,7.91H7.91c-4.37,0-7.91-3.54-7.91-7.91V7.91C0,3.54,3.54,0,7.91,0H52.07c1.81,0,4.31,1.04,5.59,2.32l13.82,13.82c1.28,1.28,2.32,3.78,2.32,5.59Zm-21.66-10.03l-.57-.57c-.37-.37-.87-.58-1.4-.58H12.52c-1.09,0-1.98,.89-1.98,1.98V29.65c0,1.09,.88,1.98,1.98,1.98H50.74c1.09,0,1.98-.89,1.98-1.98V13.09c0-.45-.26-1.08-.58-1.4Zm-4.69,41.02c0-5.82-4.72-10.54-10.54-10.54s-10.54,4.72-10.54,10.54,4.72,10.54,10.54,10.54,10.54-4.72,10.54-10.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSaveselection);
export default __webpack_public_path__ + "static/media/dark - save selection.89c16a851809b8a3d59be0e96067694e.svg";
export { ForwardRef as ReactComponent };